// extracted by mini-css-extract-plugin
export default {"button":"ButtonNotification_button__LIg7D"};